<template>
  <span>
    <a v-if="editable && measurement" type="button" class="btn btn-link no_border pull-right" @click="addNewMeasurement">
      <i class="fa-light fa-plus pulsante_comando"></i>
    </a>
    <generic-table
      :key="update"
      :headerLabels="headerLabels"
      :elements="measurements"
      :options="options"
      @openUrlEvent="openUrl"
      @removeElementEvent="removeItem"
    ></generic-table>
    <v-modal :start-closed="true" ref="modalGuestMeasurement" v-if="editable" class="medium_modal">
      <span slot="header">
        {{ i18nJS.risposta_anticorpale }}
      </span>
      <div class="control-group field obbligatorio">
        <label class="control-label" for="guest_measurement_date">{{ i18nJS.datelabel }}</label>
        <div class="controls form-inline">
          <datepicker v-model="guestMeasurement.date" id="guest_measurement_date" />
          <label for="guest_measurement_time">-</label>
          <timepicker v-model="guestMeasurement.time" id="guest_measurement_time" />
        </div>
      </div>
      <div v-for="(label, field) in resultFields" class="control-group" :key="field">
        <label class="control-label">{{ label }}</label>
        <div class="controls">
          <input type="text" class="input-small" v-model="guestMeasurement[field]" />
        </div>
      </div>
      <div class="control-group">
        <div class="controls">
          <label class="checkbox" :for="`guest_measurement_war_${rand}`">
            <input type="checkbox" v-model="guestMeasurement.war" :id="`guest_measurement_war_${rand}`" />
            {{ i18nJS.war }}
          </label>
        </div>
      </div>
      <div class="control-group">
        <label class="checkbox" :for="`guest_measurement_notes_${rand}`">{{ i18nJS.notes }}</label>
        <div class="controls">
          <textarea v-model="guestMeasurement.notes" :id="`guest_measurement_notes_${rand}`" class="span6" rows="4" />
        </div>
      </div>
      <a slot="footer" ref="btnSave" class="btn btn-success" href="javascript:void(0)" @click="save">
        {{ i18nJS['save'] }}
      </a>
    </v-modal>
  </span>
</template>
<script>
import genericTable from '../genericTable/genericTable';
import apiConnector from '@/epersonam/apiConnector';
import { RandomNumber } from '§/mixin/commonMixins.js';
import { LabelApi } from '@/epersonam/mixins/labels.js';
import vModal from '../vModal';
import datepicker from '../datepicker';
import timepicker from '../timepicker';

export default {
  name: 'guestMeasurements',
  props: { editable: { type: Boolean, default: false }, gpdsId: Number, measurementCod: String, serializer: String, columnKeys: Object },
  mixins: [LabelApi, RandomNumber],
  components: {
    genericTable,
    vModal,
    datepicker,
    timepicker,
  },
  data() {
    return {
      guestMeasurements: [],
      measurement: null,
      modalTitle: '',
      modal: null,
      guestMeasurement: {},
      update: false,
      options: {
        actionColumnEnabled: this.editable,
        canOpenUrl: this.editable,
        canDeleteRow: this.editable,
        actionButtons: [],
        htmlContent: true,
      },
    };
  },
  computed: {
    url() {
      return `/it/guest_period_data_sets/${this.gpdsId}/guest_measurements.json?view=vue&paginate=false`;
    },
    resultFields() {
      let index = 1,
        result_labels = {};
      if (!this.measurement) return result_labels;

      while (this.measurement[`desval${index}`]) {
        result_labels[`result${index > 1 ? index : ''}`] = this.measurement[`desval${index}`];
        index += 1;
      }
      return result_labels;
    },
    measurements() {
      if (!this.measurement) return;

      const result_labels = Object.keys(this.columnKeys).concat(Object.keys(this.resultFields));

      const guestsMeasurementsOrdered = [...this.guestMeasurements];

      return guestsMeasurementsOrdered.sort(this.compareDate).map((gm) => result_labels.map((key) => gm[key]));
    },
    headerLabels() {
      if (!this.measurement) return;

      const desvals = Object.values(this.resultFields);

      return Object.values(this.columnKeys)
        .map((label) => this.i18nJS[label])
        .concat(desvals);
    },
  },
  async beforeMount() {
    this.neededlabels = Object.values(this.columnKeys).concat(['datelabel', 'notes', 'war', 'command.confirm', 'risposta_anticorpale']);
    await this.setupLabels();
  },
  async mounted() {
    if (this.$refs.modalGuestMeasurement) this.modal = $(this.$refs.modalGuestMeasurement.$el);
    await this.getMeasurements();
    this.update = !this.update;
  },
  methods: {
    save() {
      Loader.show();
      if (this.guestMeasurement.id) {
        apiConnector()
          .put(`/it/guest_period_data_sets/${this.gpdsId}/guest_measurements/${this.guestMeasurement.id}.json?view=vue`, {
            guest_measurement: this.guestMeasurement,
          })
          .then(({ data }) => {
            const index = this.guestMeasurements.findIndex((t) => t.id === this.guestMeasurement.id);
            this.$set(this.guestMeasurements, index, data);
            this.modal.modal('hide');
          })
          .finally(() => Loader.hide());
      } else {
        apiConnector()
          .post(this.url, { guest_measurement: this.guestMeasurement })
          .then(({ data }) => {
            this.guestMeasurements.push(data);
            this.modal.modal('hide');
          })
          .finally(() => Loader.hide());
      }
    },
    addNewMeasurement() {
      if (!this.measurement) return;

      this.guestMeasurement = {
        date: moment().format(i18nJS.time.formats.date_only),
        time: moment().format('HH:mm'),
        exam_id: this.measurement.id,
        guest_period_data_set_id: this.gpdsId,
      };
      this.modal.modal('show');
    },
    removeItem(element, index) {
      if (this.guestMeasurements[index] && confirm(this.i18nJS.command.confirm)) {
        const id = this.guestMeasurements[index].id;
        Loader.show();
        apiConnector()
          .delete(`/it/guest_period_data_sets/${this.gpdsId}/guest_measurements/${id}.json`)
          .then(() => {
            this.guestMeasurements = this.guestMeasurements.filter((ev) => id != ev.id);
          })
          .finally(() => Loader.hide());
      }
    },
    openUrl(_guestMeasurement, index) {
      this.guestMeasurement = this.guestMeasurements[index];
      this.modal.modal('show');
    },
    compareDate(a, b) {
      if (a.db_date < b.db_date) return 1;
      if (a.db_date > b.db_date) return -1;

      return 0;
    },
    async getMeasurements() {
      if (!this.measurementCod) return;

      try {
        const measurements = await apiConnector().get(`/it/measurements.json?cod=${this.measurementCod}`);
        this.measurement = measurements.data[0];
        if (!this.measurement) return;

        const url = `${this.url}&q[exam_id_in][]=${this.measurement.id}`;
        apiConnector()
          .get(url)
          .then(({ data }) => (this.guestMeasurements = data));
      } catch {
        console.error('Misurazione non presente');
      }
    },
  },
};
</script>
